export default __webpack_public_path__ + "static/media/dds_casino_resized.b635195c.png";